<template>
  <div class="block result-block position-relative">
    <div
      v-if="loader"
      class="position-absolute d-flex expert-loader"
    >
      <b-spinner />
    </div>
    <form
      method="post"
      class="assignment-form"
      :name="expert.id"
    >
      <input
        type="hidden"
        class="input-assignment-id"
        name="assignment[id]"
        :value="relevantAssignmentId"
      >
      <input
        type="hidden"
        class="input-expert-id"
        name="assignment[expert_id]"
        :value="expert.id"
      >
      <input
        v-if="project"
        type="hidden"
        class="input-project-id"
        name="assignment[project_id]"
        :value="projectComputed.id"
      >
      <div class="block-content">
        <button
          v-if="listType === 'expert-list' && currentRouteName === `backend.add.expert` && !relevantAssignmentId"
          type="button"
          class="btn btn-sm btn-success details-btn"
          @click.stop.prevent="handleSelectAllExperiences"
        >
          Select All & Add
        </button>

        <button
          type="button"
          class="btn btn-sm assignment-form-submit-btn"
          :class="classString"
          :value="expert.id"
          @click="toggleAssignment"
        >
          {{ buttonText }}
        </button>
        <div class="block-content-grid">
          <div class="block-content-grid-item expert-name">
            <div
              v-if="currentRouteName !== 'backend.add.expert' && currentRouteName !== 'backend.expert.view'"
              class="custom-control custom-checkbox custom-control-lg mb-1"
              :class="customControlType"
            >
              <input
                :id="`selectExpertCheckbox${expert.id}`"
                v-model="mainCheckComputed"
                type="checkbox"
                class="custom-control-input select-expert-checkbox"
                name="expert[id]"
                :value="false"
                :disabled="checkBoxDisabled"
              >
              <label
                class="custom-control-label"
                :for="`selectExpertCheckbox${expert.id}`"
              >
                <span>
                  <small class="expert-id">{{ expert.id }}</small>
                </span>
                <span
                  v-if="expertUnsubscribed"
                  class="badge bg-warning ms-1 dnc-badge"
                >DNC</span>
                <span>
                  <b class="user-full-name">{{ user.full_name }}</b>
                  <a
                    target="_blank"
                    :href="`/admin/experts/view/${expert.id}`"
                    class="badge bg-primary expert-profile-badge-link"
                  >Profile</a>
                  <span v-if="expert.expert_pay_info && expert.expert_pay_info.client_credit > 1">
                    <img
                      style="height: 1em"
                      src="/img/nodes_premium_badge.jpg"
                      alt="credit"
                    >
                  </span>
                </span>
              </label>
            </div>
            <div v-else>
              <span>
                <small class="expert-id">{{ expert.id }}</small>
              </span>
              <span
                v-if="expertUnsubscribed"
                class="badge bg-warning ms-1 dnc-badge"
              >DNC</span>
              <span>
                <b class="user-full-name">{{ user.first_name }} {{ user.last_name }}</b>
                <a
                  target="_blank"
                  :href="`/admin/experts/view/${expert.id}`"
                  class="badge bg-primary expert-profile-badge-link"
                >Profile</a>
              </span>
            </div>

            <div v-if="project">
              <b-dropdown
                v-if="(isSuperAdmin || (routes['backend_assignment_status_view'] && routes['backend_assignment_rank_change'])) && relevantAssignment"
                split
                :text="rankComputed.name"
                class="mt-1 mini-btn"
                :variant="rankComputed.class"
              >
                <b-dropdown-item-button
                  v-for="(status, ib) in expertRanks"
                  :key="`yktyu${ib}`"
                  @click.stop.prevent="updateExpertsRank(status.value)"
                >
                  {{ status.name }}
                </b-dropdown-item-button>
              </b-dropdown>
            </div>
          </div>
          <div class="block-content-grid-item">
            <div v-if="currentRouteName === 'backend.project.details' || currentRouteName === 'backend.project.details.showAll'">
              <div
                v-if="relevantAssignmentPaid"
                class="text-center"
              >
                <b-button variant="secondary">
                  {{ relevantAssignmentStatus }} &dollar;{{ relevantAssignment.value }}
                </b-button>
              </div>
              <div
                v-else
                class="btkn-group"
              >
                <b-dropdown
                  v-if="(isSuperAdmin || routes['backend_assignment_status_view']) && relevantAssignment"
                  :id="'assignment-status-update-dropdown'"
                  split
                  :text="relevantAssignmentStatus"
                  :variant="statusStyles[relevantAssignmentStatus] ? statusStyles[relevantAssignmentStatus] : statusStyles['Default']"
                >
                  <b-dropdown-item-button
                    v-for="(status, ib) in allAssignmentStatuses"
                    :key="`yrtyu${ib}`"
                    @click.stop.prevent="updateAssigmentStatus(status)"
                  >
                    {{ status.name }}
                  </b-dropdown-item-button>
                </b-dropdown>
              </div>
            </div>
            <div v-else>
              <!--<a class="expert-bio-link" :href="`/admin/expert-bio/${user.id}`" v-if="routes['backend_expert_bio']">
                                                                                                                    <i class="fa fa-street-view fa-2x" :class="[expert.not_updated_jobs && expert.not_updated_jobs.length > 0 ? 'non-updated-bio' : 'updated-bio']"></i>
                                                                                                                  </a>-->
            </div>
          </div>
          <div class="block-content-grid-item badges">
            <expert-payment-request
              v-if="relevantAssignmentStatus && relevantAssignmentStatus !== 'Declined' && (isSuperAdmin || routes['backend_project_api_send_payment_request']) && currentRouteName === 'backend.project.details'"
              :project="project"
              :assignment-id="relevantAssignmentId"
              :staff-user="meComputed"
              :expert-user="user"
              :current-status="relevantAssignmentStatus"
              :assignment-statuses="allAssignmentStatuses"
            />

            <expert-hourly-rate-update
              v-if="isSuperAdmin || routes['backend_expert_hourly_rate_view']"
              :user="user"
            />

            <expert-terms-condition-badge
              :expert="expert"
              :show-expert-btn="showExpertBtn"
              :current-route-name="currentRouteName"
              :project-title="project ? project.project_title : ''"
            />

            <button
              v-if="showInvoiceExportBtn"
              type="button"
              class="btn btn-sm btn-outline-secondary ms-1 px-2 btn-invoice-export"
              data-bs-toggle="tooltip"
              title="Export Invoice"
              @click.stop.prevent="$refs[`invoiceModal_${expert.id}`].show()"
            >
              <i class="fa fa-file-invoice-dollar" /> Export Invoice
            </button>
          </div>

          <div
            v-if="showExpertBtn"
            :class="['expert-buttons', `expert-buttons-${expert.id}`, 'block-content-grid-item']"
          >
            <div class="btn-group">
              <a
                class="expert-linkedin-url"
                target="_blank"
                :href="expert.linkedin_url"
              >
                <button
                  type="button"
                  class="btn btn-sm btn-primary"
                  data-bs-toggle="tooltip"
                  :title="expert.linkedin_url ? 'LinkedIn' : 'User has no LinkedIn'"
                  :disabled="expert.linkedin_url == null"
                >
                  <i class="fab fa-linkedin-in" />
                </button>
              </a>

              <button
                v-if="isSuperAdmin || routes['backend_magic_generate_expert_login_only']"
                type="button"
                class="btn btn-sm btn-yellow ms-1 magic-generateExpertLoginOnly"
                data-bs-toggle="tooltip"
                title="Generate Magiclink for Expert to Login Only"
                @click.stop.prevent="generateExpertLoginOnly"
              >
                <i class="fa fa-link" />
              </button>

              <expert-send-welcome-email-button
                v-if="isSuperAdmin || routes['backend_expert_send_welcome_email']"
                :expertid="expert.id"
                :count="user.received_emails_expert_registered_count"
              />

              <a
                v-if="phone && project && currentRouteName === 'backend.project.details' && (isSuperAdmin || routes['backend_dummy_expert_whatsapp'])"
                :href="!project ? '' : `https://api.whatsapp.com/send?phone=${phone}&amp;text=${wpmessageComputed}`"
                :target="!project ? '' : '_blank'"
                data-bs-toggle="tooltip"
                :title="!project ? 'Only available within the project' : 'Send whatsApp message'"
                class="ms-1"
              >
                <button
                  type="button"
                  class="btn btn-sm btn-success"
                  :disabled="!project"
                >
                  <i class="fab fa-whatsapp" />
                </button>
              </a>

              <button
                v-if="(currentRouteName === 'backend.project.details' || currentRouteName === 'backend.project.details.showAll') && (isSuperAdmin || routes['backend_magic_generate_expert_assignment'])"
                type="button"
                class="btn btn-sm btn-secondary ms-1"
                name="expert-magic-generateExpertAssignment"
                data-bs-toggle="tooltip"
                title="Generate MagicLink to Assignment"
                @click.stop.prevent="generateExpertAssignment"
              >
                <i class="fas fa-bolt" />
              </button>

              <a
                v-if="(isSuperAdmin || routes['backend_assignment_calendar_view']) && relevantAssignment"
                class="assignment-calendar-view-link"
                :href="`/admin/assignment/calendar/view/${relevantAssignment.id}`"
              >
                <button
                  type="button"
                  class="btn btn-sm btn-purple ms-1"
                  data-bs-toggle="tooltip"
                  title="Calendar"
                >
                  <i class="fas fa-calendar-alt" />
                </button>
              </a>

              <a
                v-if="(isSuperAdmin || routes['backend_assignment_calendar_new']) && relevantAssignment"
                class="assignment-calendar-new-view-link"
                :href="`/admin/assignment/new-calendar/${relevantAssignment.id}`"
              >
                <button
                  type="button"
                  class="btn btn-sm btn-primary ms-1"
                  data-bs-toggle="tooltip"
                  title="Calendar"
                >
                  <i class="fas fa-calendar" />
                </button>
              </a>

              <a
                v-if="isSuperAdmin || (routes['backend_expert_edit'] && (routes['backend_dummy_expert_can_edit_any'] || Number(expert.created_by) === Number(me.id)))"
                class="expert-edit-link"
                :href="`/admin/experts/edit/${expert.id}`"
              >
                <button
                  type="button"
                  class="btn btn-sm btn-orange ms-1"
                  data-bs-toggle="tooltip"
                  title="Edit"
                >
                  <i class="fa fa-fw fa-pencil-alt" />
                </button>
              </a>

              <expert-update-payment-button
                v-if="(isSuperAdmin || routes['backend_expert_api_payment_update']) && currentRouteName === 'backend.project.details'"
                v-show="relevantAssignmentStatus === 'Completed'"
                ref="updatePaymentBtn"
                :expert-id="expert.id"
                :assignment-id="relevantAssignmentId"
                :assignment="relevantAssignment"
                @update-expert-status="changeAssigmentStatus"
              />

              <button
                v-if="(isSuperAdmin || routes['backend_expert_delete']) && currentRouteName == backendExpertIndex"
                type="button"
                class="btn btn-sm btn-red ms-1 delete-expert-btn"
                data-bs-toggle="tooltip"
                title="Delete"
                @click.stop.prevent="deleteExpert(expert.id)"
              >
                <i class="fa fa-trash" />
              </button>
            </div>

            <div v-if="magicLink || magicAssignmentLink">
              <a
                v-if="magicLink"
                :href="magicLink"
                target="_blank"
              >Expert Login to Dashboard</a>

              <a
                v-if="magicAssignmentLink"
                :href="magicAssignmentLink"
                target="_blank"
              >Magic Redirect to Assignment</a>
            </div>

            <div v-if="oldMagicLink">
              <a
                v-if="oldMagicLink"
                :href="oldMagicLink"
                target="_blank"
              >Expert Login to Old Dashboard</a>
            </div>
          </div>

          <div class="block-content-grid-item user-email">
            <label>Email</label>
            <span class="no-break">{{ user.email }}</span>
          </div>
          <div class="block-content-grid-item user-email">
            <label>Secondary email</label>
            <span class="no-break">{{ user.email_2 }}</span>
          </div>
          <div class="block-content-grid-item user-country">
            <label>Country</label>
            {{ user.country }}
          </div>
          <div class="block-content-grid-item expert-industry">
            <label>Industry</label>
            {{ expert.industry.industry_name }}
          </div>
          <div class="block-content-grid-item">
            <label>Mobile</label>
            <a
              class="user-mobile-phone"
              :href="`tel: +${user.mobile_phone_code} ${user.mobile_phone}`"
            >
              {{ user.mobile_phone ? "+" : "" }}{{ user.mobile_phone ? user.mobile_phone_code : "" }}
              {{ user.mobile_phone }}
            </a>
          </div>
          <div class="block-content-grid-item">
            <label>Phone 2</label>
            <a
              class="user-business-phone"
              :href="`tel: ${user.business_phone_code} ${user.business_phone}`"
            >
              {{ user.business_phone ? "+" : "" }}{{ user.business_phone ? user.business_phone_code : "" }} {{ user.business_phone }}
            </a>
          </div>
          <div
            v-if="expert.assigned_staff && expert.assigned_staff.user"
            class="block-content-grid-item expert-assigned-staff"
          >
            <label>Staff</label>
            {{ expert.assigned_staff.user.first_name }} {{ expert.assigned_staff.user.last_name }}
          </div>
          <div class="block-content-grid-item">
            <label>Referred by</label>
            WIP
          </div>
          <div class="block-content-grid-item">
            <label>Time Zone</label>{{ user.time_zone }}
          </div>
        </div>
      </div>

      <div class="block-content">
        <expert-comment-list-block
          v-if="currentRouteName === 'backend.project.details'"
          :expert-name="user.full_name"
          :project-staffs="projectStaffs"
          :user-logged-id="userLoggedId"
          :assignment-id="relevantAssignment.id"
          :assignment-comment-count="relevantAssignment.comments_count"
        />
      </div>

      <expert-result-summary-block
        v-if="currentRouteName === 'backend.project.details'"
        :project-title="project.project_title"
        :project-description="project.project_description"
        :summary="expertSummaryText"
        :bio-highlight="expertBio"
        :expert="expert"
        :project-id="relevantAssignment.project_id"
        :expert-id="relevantAssignment.expert_id"
        :assignment-id="relevantAssignment.id"
      />

      <expert-summary-select-button
        v-if="currentRouteName === 'backend.expert.index'"
        :expert="expert"
        :bio-highlight="expertBio"
      />

      <div class="block-content">
        <expert-resume-upload
          v-if="resumeComponentPages.includes(currentRouteName)"
          :expert-id="expert.id"
          :expert-resume="expert.expert_bio && expert.expert_bio.resume_url"
        />
      </div>

      <div class="block-content block-options">
        <button
          type="button"
          class="btn btn-sm btn-outline-dark preview-btn mb-3"
          @click.stop.prevent="toggleJobExperiencesBlock = !toggleJobExperiencesBlock"
        >
          {{ toggleJobExperiencesBlock ? "Hide" : "Show" }} preview
        </button>
        <button
          v-show="toggleJobExperiencesBlock"
          type="button"
          class="btn btn-sm btn-dark details-btn mb-3"
          @click.stop.prevent="toggleExperienceContent = !toggleExperienceContent"
        >
          {{ toggleExperienceContent ? "Hide" : "Show" }} details
        </button>
      </div>

      <!-- Job Experiences -->
      <div
        v-show="toggleJobExperiencesBlock"
        :id="`jobExperiencesBlock${expert.id}`"
        class="block job-experiences-block"
      >
        <expert-job-experience
          v-for="(experience, loopKey) in jobExperienceComputed"
          :key="`hgytj${loopKey}`"
          :loop-key="loopKey"
          :experience="experience"
          :expert="expert"
          :current-route-name="currentRouteName"
          :check-box-disabled="checkBoxDisabled"
          :routes="routes"
          :toggle-experience-content="toggleExperienceContent"
          :attached-job-experience-ids="attachedJobExperienceIds"
          :relevant-assignment="relevantAssignment"
          :main-check="mainCheck"
          :user="user"
          :project="project"
          :job-experience-checked="jobExperienceChecked"
          @toJobsSelected="toJobsSelected"
          @removeJobsSelected="removeJobsSelected"
        />
      </div>

      <!-- Searched answers -->
      <div
        v-if="(searchedAnswers.length > 0 || searchedQuestions.length > 0) && currentRouteName === 'backend.expert.index'"
        class="block-content"
      >
        <b-badge
          pill
          variant="info"
        >
          Matched project question & answers
        </b-badge>
        <div v-if="searchedAnswers.length">
          <b-row
            v-for="(searchedAnswer, index) in searchedAnswers"
            :key="index"
          >
            <b-col class="font-weight-bold">
              <a
                :href="`/admin/project/details/${searchedAnswer.project.id}`"
                target="_blank"
              >
                {{ searchedAnswer.project.project_title }}
              </a>
            </b-col>
            <b-col>{{ searchedAnswer.question }}</b-col>
            <b-col>{{ searchedAnswer.answer }}</b-col>
          </b-row>
        </div>
        <div v-else-if="searchedQuestions.length > 0">
          <b-row
            v-for="(searchedAnswer, index) in searchedQuestions"
            :key="index"
          >
            <b-col class="font-weight-bold">
              <a
                :href="`/admin/project/details/${searchedAnswer.project.id}`"
                target="_blank"
              >
                {{ searchedAnswer.project.project_title }}
              </a>
            </b-col>
            <b-col>{{ searchedAnswer.question }}</b-col>
            <b-col>{{ searchedAnswer.answer }}</b-col>
          </b-row>
        </div>
      </div>

      <div
        v-if="searchedProjectHighlights.length && currentRouteName === 'backend.expert.index'"
        class="block-content"
      >
        <h5>
          <b-badge
            pill
            variant="info"
          >
            Matched project highlights
          </b-badge>
        </h5>
        <b-row
          v-for="(highlight, index) in searchedProjectHighlights"
          :key="index"
        >
          <b-col class="font-weight-bold">
            <a
              :href="`/admin/project/details/${highlight.project.id}`"
              target="_blank"
            >
              {{ highlight.project.project_title }}
            </a>
          </b-col>
          <b-col v-html="highlight.summary" />
        </b-row>
      </div>

      <div
        v-if="searchedLinkedinBio !== null && currentRouteName === 'backend.expert.index'"
        class="block-content"
      >
        <h5>
          <b-badge
            pill
            variant="info"
          >
            Matched Linkedin Bio
          </b-badge>
        </h5>
        <div v-html="searchedLinkedinBio" />
      </div>

      <!--      <div
                                            v-if="searchedMainSummary !== null && currentRouteName === 'backend.expert.index'"
                                            class="block-content"
                                          >
                                            <h5>
                                              <b-badge
                                                pill
                                                variant="info"
                                              >
                                                Matched Main Summary
                                              </b-badge>
                                            </h5>
                                            {{ searchedMainSummary }}
                                          </div>-->

      <!-- Answer section for project details page -->
      <div
        v-if="
          routes['backend_assignment_questions_and_answers_view'] && questions.length > 0 && (currentRouteName === 'backend.project.details' || currentRouteName === 'backend.project.details.showAll')
        "
        class="block-content questions-and-answers-block py-0 my-0"
      >
        <div class="qa-list">
          <div
            v-for="(item, infre) in questionsWithExpertAnswers"
            :key="`qa-${expert.id}-${item.question.id || infre}`"
            class="qa-row"
            :class="[`qa-row--${item.typeMeta.key}`, { 'qa-row--empty': !item.hasAnswers }]"
          >
            <div class="qa-row__rail">
              <span
                class="qa-type"
                :class="`qa-type--${item.typeMeta.key}`"
                :title="item.typeMeta.label"
              >
                <i
                  :class="item.typeMeta.icon"
                  aria-hidden="true"
                />
                <span class="qa-type__text">{{ item.typeMeta.label }}</span>
              </span>
            </div>

            <div class="qa-row__body">
              <p class="qa-question">
                <span class="qa-question__num">{{ infre + 1 }}</span>{{ item.question.question }}
              </p>

              <!-- single / multi: full option set, selected solid + unselected muted -->
              <div
                v-if="item.typeMeta.key !== 'text'"
                class="qa-answer"
              >
                <span
                  v-for="(opt, oi) in item.options"
                  :key="`o${infre}-${oi}`"
                  class="qa-opt"
                  :class="opt.selected ? 'qa-opt--on' : 'qa-opt--off'"
                >
                  <i
                    :class="optionIcon(item.typeMeta.key, opt.selected)"
                    aria-hidden="true"
                  />{{ opt.label }}
                </span>
                <!-- fallback for legacy rows whose options were deleted -->
                <template v-if="!item.options.length">
                  <span
                    v-for="(lbl, li) in item.selectedOptions"
                    :key="`f${infre}-${li}`"
                    class="qa-opt qa-opt--on"
                  >{{ lbl }}</span>
                </template>
              </div>

              <!-- fill_the_blank: legacy Yes/No verdict pill; omitted entirely when null.
                   Background comes from the OneUI *-light helper (dark-mode aware). -->
              <div
                v-else-if="item.answerTypeName"
                class="qa-answer"
              >
                <span
                  class="qa-verdict"
                  :class="[`qa-verdict--${item.verdict}`, verdictMeta(item.verdict).bg]"
                >
                  <i
                    :class="verdictMeta(item.verdict).icon"
                    aria-hidden="true"
                  />{{ item.answerTypeName }}
                </span>
              </div>

              <p
                v-if="item.comment"
                class="qa-comment"
              >
                <i
                  class="fa fa-comment-dots"
                  aria-hidden="true"
                />
                <span>{{ item.comment }}</span>
              </p>

              <p
                v-if="!item.hasAnswers"
                class="qa-noanswer"
              >
                <i
                  class="fa fa-circle-minus"
                  aria-hidden="true"
                />No answer submitted
              </p>
            </div>
          </div>
        </div>
      </div>

      <invoice-export-modal
        v-if="showInvoiceExportBtn"
        :ref="`invoiceModal_${expert.id}`"
        :project-id="project.id"
        :expert-id="expert.id"
      />
    </form>
  </div>
</template>
<script>
import mixin from "../../../mixins/mixin";
import permissions from "../../../mixins/permissions";
import Vue from "vue";
import { mapGetters } from "vuex";
import ExpertTermsConditionBadge from "./ExpertTermsConditionBadge.vue";
import InvoiceExportModal from "../project/InvoiceExportModal.vue";

export default {
  components: {
    ExpertTermsConditionBadge,
    InvoiceExportModal,
  },
  mixins: [mixin, permissions],
  props: {
    user: {
      type: Object,
      required: true,
    },
    me: {
      type: Object,
      required: true,
    },
    currentRouteName: {
      type: String,
      required: false,
      default() {
        return "";
      },
    },
    wpmessage: {
      type: String,
      required: false,
      default() {
        return "";
      },
    },
    project: {
      type: Object,
      required: false,
      default() {
        return null;
      },
    },
    routes: {
      type: [Object, Array],
      required: true,
    },
    hideJobExperiences: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },
    allAssignmentStatuses: {
      type: [Object, Array],
      required: false,
      default() {
        return [];
      },
    },
    attachedJobExperienceIds: {
      type: [Object, Array],
      required: false,
      default() {
        return [];
      },
    },
    questions: {
      type: [Object, Array],
      required: false,
      default() {
        return [];
      },
    },
    projectStaffs: {
      type: [Object, Array],
      required: false,
      default() {
        return [];
      },
    },
    userLoggedId: {
      type: [String, Number],
      required: false,
      default() {
        return "";
      },
    },
    showExpertBtn: {
      type: Boolean,
      default: true,
    },
    mainKw: {
      type: String,
      default: "",
    },
    listType: {
      type: String,
      default: "project-list",
    },
  },
  data() {
    return {
      resumeComponentPages: ["backend.expert.index", "backend.project.details"],
      options: ["Attached", "Invited", "Accepted", "Declined", "Call Scheduled", "Call Completed", "Paid"],
      classString: "",
      buttonText: "",
      customControlType: "custom-control-dark",
      checkBoxDisabled: false,
      assignmentStatusName: "",
      toggleJobExperiencesBlock: true,
      loader: false,
      toggleExperienceContentLocal: false,
      magicLink: null,
      oldMagicLink: null,
      magicAssignmentLink: null,
      mainCheck: false,
      jobsSelected: [],
      expertRanks: [
        { name: "No rank", class: "default", value: 0 },
        { name: "Very low rank", class: "info", value: 1 },
        { name: "Low rank", class: "info", value: 2 },
        { name: "Mid rank", class: "info", value: 3 },
        { name: "High rank", class: "warning", value: 4 },
        { name: "Superior", class: "warning", value: 5 },
      ],
      declinedStatusId: 4,
    };
  },
  computed: {
    mainCheckComputed: {
      set(val) {
        this.mainCheck = val;
      },
      get() {
        return this.mainCheck;
      },
    },
    rankComputed() {
      const ret = this.expertRanks.filter((e) => {
        const expertRank = this.relevantAssignment && this.relevantAssignment.expert_rank ? this.relevantAssignment.expert_rank : 0;
        return Number(expertRank) === e.value;
      });
      if (ret.length > 0) {
        return ret[0];
      }
      return { name: "Unknown", class: "default", value: 0 };
    },
    relevantAssignment() {
      if (!this.project || !this.project.id) return null;
      const res = this.expert.assignments.filter((v) => Number(this.project.id) === Number(v.project_id));

      if (res.length > 0 && this.$store.state.expert.assignmentStatusFilterSelected) {
        const resFilterStatus = res.filter((v) => Number(this.$store.state.expert.assignmentStatusFilterSelected.id) === Number(v.status_id));
        if (resFilterStatus.length) return resFilterStatus[0];
      }
      return res.length > 0 ? res[0] : null;
    },
    relevantAssignmentId() {
      if (!this.relevantAssignment) {
        return null;
      }
      return Number(this.relevantAssignment.id);
    },
    relevantAssignmentStatus() {
      if (this.relevantAssignment && this.relevantAssignment.status) {
        return this.relevantAssignment.status.name;
      }

      return "";
    },
    relevantAssignmentPaid() {
      return this.relevantAssignmentStatus === "Paid";
    },
    toggleExperienceContent: {
      set() {
        this.toggleExperienceContentLocal = !this.toggleExperienceContentLocal;
      },
      get() {
        return this.toggleExperienceContentLocal;
      },
    },
    expert() {
      return { full_name: this.user.full_name, ...this.user.expert } || {};
    },
    questionsWithExpertAnswers() {
      const list = Array.isArray(this.questions) ? this.questions : Object.values(this.questions || {});
      return list.map((question) => {
        const answers = (question.answers || []).filter((a) => Number(a.expert_id) === Number(this.expert.id));
        const typeName = question.type ? question.type.name : "";
        const typeMeta = this.questionTypeMeta(typeName);
        const selectedIds = new Set(
          answers
            .map((a) => a.question_option_id ?? (a.option && a.option.id))
            .filter((v) => v != null)
            .map(Number)
        );
        const options = (question.options || []).map((o) => ({
          id: o.id,
          label: o.option,
          selected: selectedIds.has(Number(o.id)),
        }));
        const selectedOptions = [...new Set(answers.filter((a) => a.option).map((a) => a.option.option))];
        const comment = answers.map((a) => a.answer).find((t) => t) || "";
        const answerTypeName = answers.map((a) => a.type && a.type.answer_type_name).find((t) => t) || "";
        const verdictKey = answerTypeName.trim().toLowerCase();
        let verdict = "none";
        if (verdictKey === "yes") {
          verdict = "yes";
        } else if (verdictKey === "no") {
          verdict = "no";
        } else if (verdictKey.includes("allow")) {
          verdict = "restricted";
        }
        return {
          question,
          typeName,
          typeMeta,
          options,
          selectedOptions,
          comment,
          answerTypeName,
          verdict,
          hasAnswers: answers.length > 0,
        };
      });
    },
    projectComputed() {
      return this.project || {};
    },
    phone() {
      if (this.user.mobile_phone_code && this.user.mobile_phone) {
        return this.getCleanPhone(this.user.mobile_phone_code, this.user.mobile_phone);
      } else if (this.user.business_phone_code && this.user.business_phone) {
        return this.getCleanPhone(this.user.business_phone_code, this.user.business_phone);
      }

      return null;
    },
    hideJobExperiencesComputed() {
      return this.hideJobExperiences;
    },
    wpmessageComputed() {
      let str = this.wpmessage;
      str = str.replace(":firstName", this.user.first_name);
      if (this.project) {
        str = str.replace(":projectTitle", this.project.project_title);
      } else {
        str = str.replace(" regarding the project on :projectTitle", "");
      }
      str.replace(":projectTitle", this.user.first_name);
      str = str.replace(":staffFirstName", this.me.first_name);
      return encodeURIComponent(str);
    },
    meComputed() {
      return this.me;
    },
    lastJobExperience() {
      return this.expert.sorted_job_experiences.length > 0 ? this.expert.sorted_job_experiences[0] : null;
    },
    selectAllExpertsGlobal() {
      return this.$store.state.expert.selectAllExperts;
    },
    jobExperienceChecked() {
      if (this.currentRouteName === "backend.add.expert") {
        /*console.log('assignmentId', this.relevantAssignmentId);
                if(this.relevantAssignmentId) {
                    return [];
                }*/

        if (this.expert.sorted_job_experiences.length > 0) {
          const arr = this.expert.sorted_job_experiences.filter((v) => {
            if (!v.assignments) return false;
            const res = v.assignments.find((o) => Number(this.project.id) === Number(o.project_id));
            return res ? true : false;
          });
          return arr.map((v) => Number(v.id));
        }
      }

      return [];
    },
    jobExperienceComputed() {
      if (!this.relevantAssignment || this.currentRouteName === "backend.add.expert") return this.expert.sorted_job_experiences;
      if (this.expert.sorted_job_experiences.length > 0) {
        return this.expert.sorted_job_experiences.filter((v) => {
          const res = v.assignments.find((o) => Number(this.project.id) === Number(o.project_id));
          return res ? true : false;
        });
      }
      return [];
    },
    expertSummaryText() {
      if (this.project !== null && this.project.include_expert_highlight === 1) {
        const linkedInBio = this.expert.expert_bio && this.expert.expert_bio.bio_writeup === "undefined" ? "" : this.expert.expert_bio.bio_writeup;
        return this.relevantAssignment?.expert_summary ?? this.expert.expert_bio.main_summary ?? linkedInBio;
      }

      return this.relevantAssignment?.expert_summary ?? this.expert.expert_bio.main_summary ?? "";
    },
    expertBio() {
      return this.expert.expert_bio && this.expert.expert_bio.bio_writeup !== "undefined" ? this.expert.expert_bio.bio_writeup : null;
    },
    expertMainSummary() {
      return this.expert.expert_bio.main_summary === "undefined" ? null : this.expert.expert_bio.main_summary;
    },
    expertAnswers() {
      const assignments = this.expert.assignments;

      if (assignments.length > 0) {
        return assignments
          .filter((assignment) => (Array.isArray(assignment.answers) && assignment.answers.length > 0) || (Array.isArray(assignment.question) && assignment.question.length > 0))
          .flatMap((assignment) => {
            return assignment.answers
              .filter((item) => item.answer !== null)
              .map((answerItem) => {
                return {
                  answer: answerItem.answer,
                  question: answerItem.question.question,
                  project: assignment.project,
                };
              });
          });
      }
      return [];
    },
    searchedQuestions() {
      if (this.expertAnswers.length > 0 && this.mainKw !== "") {
        return this.expertAnswers.filter((itm) => {
          if (typeof itm.question === "string") {
            return itm.question.toLowerCase().includes(this.mainKw.toLowerCase());
          }

          return false;
        });
      }

      return [];
    },
    searchedAnswers() {
      if (this.expertAnswers.length > 0 && this.mainKw !== "") {
        return this.expertAnswers.filter((itm) => {
          if (typeof itm.answer === "string") {
            return itm.answer.toLowerCase().includes(this.mainKw.toLowerCase());
          }

          return false;
        });
      }

      return [];
    },
    searchedProjectHighlights() {
      if (this.mainKw !== "" && this.expert.assignments.length > 0) {
        return this.expert.assignments
          .filter((assignment) => {
            if (typeof assignment.expert_summary === "string" && assignment.expert_summary !== "" && assignment.expert_summary !== null && assignment.expert_summary !== undefined) {
              return assignment.expert_summary.toLowerCase().includes(this.mainKw.toLowerCase());
            }
          })
          .map((assignment) => ({
            summary: assignment.expert_summary,
            project: assignment.project,
          }));
      }

      return [];
    },
    searchedLinkedinBio() {
      if (this.mainKw !== "" && typeof this.expertBio === "string" && this.expertBio.toLowerCase().includes(this.mainKw.toLowerCase())) {
        return this.expertBio;
      }

      return null;
    },
    searchedMainSummary() {
      if (this.mainKw !== "" && typeof this.expertMainSummary === "string" && this.expertMainSummary.toLowerCase().includes(this.mainKw.toLowerCase())) {
        return this.expertMainSummary;
      }

      return null;
    },
    relevantPaymentRequestIsUSD() {
      if (!this.relevantAssignmentId) return true;
      const req = this.$store.getters['project/payment/requestByAssignmentId'](this.relevantAssignmentId);
      if (!req || !req.client_rate_currency) return true;
      return req.client_rate_currency === 'USD';
    },
    showInvoiceExportBtn() {
      return (
        this.isSuperAdmin &&
        this.project &&
        this.currentRouteName === "backend.project.details" &&
        (this.relevantAssignmentStatus === "Completed" || this.relevantAssignmentStatus === "Paid") &&
        this.relevantPaymentRequestIsUSD
      );
    },
    ...mapGetters({
      statusStyles: "project/statusStyles",
      selectedExpertIds: "expert/selectedExpertIds",
      isExpertUnsubscribed: "expert/isExpertUnsubscribed",
    }),
    expertUnsubscribed() {
      return this.isExpertUnsubscribed(this.expert.id);
    },
  },
  watch: {
    hideJobExperiencesComputed(nv, ov) {
      this.toggleJobExperiencesBlock = !this.hideJobExperiences;
    },
    selectAllExpertsGlobal(nv, ov) {
      this.mainCheckComputed = this.$store.state.expert.selectAllExperts;
    },
    selectedExpertIds: {
      handler(nv) {
        const isChecked = nv.some((id) => Number(id) === Number(this.expert.id));
        this.mainCheckComputed = isChecked;
      },
      immediate: true,
    },
    mainCheckComputed(nv, ov) {
      this.mainCheckChanged();
      this.$emit('expert-checked', { 
        expertId: this.expert.id, 
        checked: nv 
      });
    },
  },
  mounted() {
    /* if (this.project) {
      // Dealing with bug when we click "Back" in the browser
      setTimeout(() => {
        const id = `selectExpertCheckbox${this.expert.id}`;
        const element = document.getElementById(id);

         if (element && element.checked) {
          this.mainCheck = true;
        }

        if (this.$store.state.expert.selectedExpertIds.includes(Number(this.expert.id))) {
          this.mainCheck = true;
        }
      }, 600);
    } */

    this.toggleJobExperiencesBlock = !this.hideJobExperiences;
    this.init();

    //update expert unsubscribed status
    this.$nextTick(function () {
      const fetchedIds = this.$store.state.expert.unsubscribedStatusFetchedIds.map(Number);
      if (fetchedIds.includes(Number(this.expert.id))) {
        // Already resolved via bulk fetch — nothing to do
        return;
      }
      // Fallback for views that don't go through getProjectExperts (e.g. expert view, search list)
      this.checkExpertUnsubscribeStatus(this.expert.id).then((status) => {
        this.$store.commit("expert/addUnsubscribedStatus", {
          expertId: this.expert.id,
          unsubscribed: status,
        });
      });
    });
    
    // Listen for reset event from parent
    this.$parent.$on('reset-checkboxes', () => {
      this.mainCheck = false;
    });
  },
  methods: {
    questionTypeMeta(typeName) {
      const map = {
        multiple_choice_single_answer: { key: "single", label: "Single choice", icon: "fa fa-circle-dot" },
        multiple_choice_multiple_answer: { key: "multi", label: "Multiple choice", icon: "fa fa-list-check" },
        fill_the_blank: { key: "text", label: "Text answer", icon: "fa fa-pen-to-square" },
      };
      return map[typeName] || map.fill_the_blank;
    },
    questionTypeLabel(typeName) {
      return this.questionTypeMeta(typeName).label;
    },
    optionIcon(key, selected) {
      if (key === "single") return selected ? "fa fa-circle-dot" : "far fa-circle";
      return selected ? "fa fa-square-check" : "far fa-square";
    },
    verdictMeta(verdict) {
      return {
        yes: { icon: "fa fa-circle-check", bg: "bg-success-light" },
        no: { icon: "fa fa-circle-xmark", bg: "bg-danger-light" },
        restricted: { icon: "fa fa-ban", bg: "bg-warning-light" },
      }[verdict] || { icon: "fa fa-circle-info", bg: "bg-body-dark" };
    },
    toggleAssignment() {
      if (this.currentRouteName === "backend.add.expert") {
        if (!this.relevantAssignmentId) {
          this.createAssignment();
        } else {
          this.deleteAssignment();
        }
      }
    },
    init() {
      //this.relevantAssignment = this.project && this.expert.assignments ? this.expert.assignments.filter(p => p.project_id == this.project.id) : null;

      this.checkBoxDisabled = false;
      if (this.relevantAssignment != null && this.relevantAssignment.status.name == "Declined" && this.currentRouteName === "backend.project.details") {
        this.customControlType = "custom-control-danger";
        this.checkBoxDisabled = true;
      }

      if (this.currentRouteName === "backend.add.expert") {
        if (this.relevantAssignmentId == null) {
          this.classString = "btn-primary";
          this.buttonText = "Add";
        } else {
          this.classString = "btn-danger";
          this.buttonText = "Remove";
        }
      } else {
        this.classString = "d-none";
        this.buttonText = "";
      }

      this.assignmentStatusName = this.relevantAssignment && this.relevantAssignment.status ? this.relevantAssignment.status.name : null;
    },
    deleteExpert(id) {
      if (confirm("Are you sure you want to delete this expert?")) {
        this.realDeleteExpert(id);
      }
    },
    async realDeleteExpert(expertId) {
      const url = `/admin/experts/delete/${expertId}`;
      this.loader = true;
      try {
        const response = await axios.post(url, {});
        this.$emit("updated");
        this.loader = false;
      } catch (e) {}
    },
    async generateExpertLoginOnly() {
      const response = await axios.get(`/admin/magic/generateExpertLoginOnly/${this.expert.id}`);
      this.magicLink = response.data;

      const response2 = await axios.get(`/admin/magic/generateOldExpertLoginOnly/${this.expert.id}`);
      this.oldMagicLink = response2.data;
    },
    async generateExpertAssignment() {
      const response = await axios.get(`/admin/magic/generateExpertAssignment/${this.expert.id}/${this.relevantAssignmentId}`);
      this.magicAssignmentLink = response.data;
    },
    changeAssigmentStatus(status) {
      this.updateAssigmentStatus(status, false);
    },
    async updateAssigmentStatus(newStatus, dropdownChange = true) {
      const newStatusName = newStatus.name;

      if (!this.relevantAssignmentId) return;

      try {
        if (dropdownChange) {
          if (newStatusName === "Paid") {
            if (this.relevantAssignmentStatus !== "Completed") {
              alert("Only expert with completed status can be paid.");
            } else {
              this.$bvModal.show(this.$refs.updatePaymentBtn.modalId);
            }
            return;
          } else {
            const url = `/admin/assignment/status/change/${this.relevantAssignmentId}/${newStatusName}`;
            await axios.post(url);
          }
        }

        const assignmentStatusPayload = {
          statusName: newStatusName,
          statusId: newStatus.id,
          projectId: this.project.id,
          expertId: this.expert.id,
          assignmentId: this.relevantAssignmentId,
        };

        if (newStatusName === "Paid" && newStatus.amount && newStatus.consult_minutes) {
          assignmentStatusPayload.value = newStatus.amount;
          assignmentStatusPayload.consult_minutes = newStatus.consult_minutes;
        }

        this.$store.commit("expert/updateAssigmentStatus", assignmentStatusPayload);

        if (this.mainCheck) {
          this.mainCheckChanged();
        }

        if (this.$store.state.expert.assignmentStatusFilterSelected) {
          await this.$store.dispatch("expert/getProjectExperts", { projectId: this.project.id });
        }
      } catch (e) {
        // for some reason bootstrap toast doesn't fire in this scope
        // so we need to create a new instance
        const vm = new Vue();
        if (e.response.status === 403) {
          vm.$bvToast.toast(`You are not authorised to perform this action`, {
            title: `Error`,
            variant: "danger",
          });
        } else {
          let message = "";
          if (e.response.data && e.response.data.error && e.response.data.error.message) {
            message = e.response.data.error.message;
          } else {
            message = e.response.statusText;
          }
          vm.$bvToast.toast(`Server call returned error: ${message}`, {
            title: `${e.response.statusText} (${e.response.status})`,
            variant: "danger",
          });
        }
      }
    },
    async updateExpertsRank(value) {
      const url = `/admin/assignment/rank/change/${this.relevantAssignmentId}`;
      const response = await axios.post(url, {
        new_value: value,
      });
      this.$store.commit("expert/updateAssigmentExpertsRank", {
        assignmentId: this.relevantAssignmentId,
        expertRank: value,
        expertId: this.expert.id,
      });
    },
    mainCheckChanged() {
      const rankMap = this.$store.state.expert.usersExpertsObj.data.map((v) => {
        const t = v.expert.assignments.filter((r) => Number(r.project_id) === Number(this.project.id));
        const rank = t[0]?.expert_rank ?? 0;
        return { id: v.expert.id, rank };
      });
      if (this.mainCheck) {
        const res = [...this.$store.state.expert.selectedExpertIds];
        res.push(Number(this.expert.id));

        if (this.listType === "expert-list") {
          this.$store.commit("expert/setSelectedExpertIds", res);
        } else {
          let expertsNotDeclined = [];
          res.forEach((sid) => {
            this.$store.state.expert.usersExpertsObj.data.forEach((user) => {
              if (Number(user.expert.id) === Number(sid)) {
                user.expert.assignments.forEach((assignment) => {
                  if (Number(assignment.project_id) === Number(this.project.id) && Number(this.declinedStatusId) !== Number(assignment.status_id)) {
                    expertsNotDeclined.push(assignment.expert_id);
                  }
                });
              }
            });
          });

          const res_ = [...expertsNotDeclined];

          res_.sort((a, b) => {
            const aobj = rankMap.find((o) => Number(o.id) === Number(a));
            const bobj = rankMap.find((o) => Number(o.id) === Number(b));
            return Number(bobj.rank) - Number(aobj.rank);
          });
          this.$store.commit("expert/setSelectedExpertIds", res_);
        }
      } else {
        const storeRes = this.$store.state.expert.selectedExpertIds.filter(
          (e) => Number(e) !== Number(this.expert.id)
        );
        this.$store.commit("expert/setSelectedExpertIds", [...storeRes]);
      }
      //console.log("selectedExpertIds", this.$store.state.expert.selectedExpertIds);
    },
    handleSelectAllExperiences() {
      this.jobsSelected = [];
      const storeJobIds = this.$store.state.expert.selectedJobExpIds.filter((id) => {
        const job = this.expert.sorted_job_experiences.find((j) => Number(j.id) === Number(id));
        return !job;
      });
      this.$store.commit("expert/setSelectedJobExpIds", storeJobIds);

      const jobsToSelect = this.expert.sorted_job_experiences || [];
      jobsToSelect.forEach((job) => {
        if (this.isJobBlacklisted(job, this.project)) return;
        this.toJobsSelected(job.id);
      });

      if (this.jobsSelected.length > 0) {
        this.mainCheckComputed = true;
        if (!this.relevantAssignmentId) {
          this.createAssignment();
        }
      }
    },
    toJobsSelected(id) {
      if (!this.jobsSelected.includes(id)) {
        this.jobsSelected.push(id);
      }
      const res = [...this.$store.state.expert.selectedJobExpIds];
      res.push(id);
      this.$store.commit("expert/setSelectedJobExpIds", res);
    },
    removeJobsSelected(id) {
      const res = this.jobsSelected.filter((e) => e !== id);
      this.jobsSelected = [...res];
      const storeRes = this.$store.state.expert.selectedJobExpIds.filter((e) => e !== id);
      this.$store.commit("expert/setSelectedJobExpIds", [...storeRes]);
    },
    async createAssignment() {
      if (this.jobsSelected.length === 0) {
        alert("At least one job experience must be selected.");
        return;
      }
      const assignment = {
        id: this.relevantAssignmentId,
        project_id: this.project.id,
        expert_id: this.expert.id,
      };
      const jobExperienceIds = [...this.jobsSelected];

      try {
        const response = await axios.post("/admin/assignment/create", {
          assignment,
          jobExperienceIds,
        });

        if (Boolean(response.data.success)) {
          One.helpers("jq-notify", { type: "success", icon: "fa fa-check me-1", message: "Added!" });
          this.classString = "btn-danger";
          this.buttonText = "Remove";
          const assignmentId = response.data.assignmentId;
          const expertId = response.data.expertId;
          const projectId = response.data.projectId;
          const index = this.expert.assignments.length;
          this.$store.commit("expert/createAssignment", { assignmentId, projectId, expertId });
        } else {
          One.helpers("jq-notify", { type: "danger", icon: "fa fa-check me-1", message: response.data.error });
        }
      } catch (e) {
        One.helpers("jq-notify", { type: "danger", icon: "fa fa-check me-1", message: e.response.data.error });
      }
    },
    async deleteAssignment() {
      const assignment = {
        id: this.relevantAssignmentId,
        project_id: this.project.id,
        expert_id: this.expert.id,
      };
      try {
        const response = await axios.post("/admin/assignment/delete", { assignment });
        if (response.data.success) {
          One.helpers("jq-notify", { type: "success", icon: "fa fa-check me-1", message: "Removed!" });
          this.classString = "btn-primary";
          this.buttonText = "Add";
          const assignmentId = response.data.data.assignment.id;
          const expertId = this.expert.id;
          this.$store.commit("expert/removeAssignment", { assignmentId, expertId });

          this.mainCheckComputed = false; // Uncheck the expert
        }
      } catch (e) {
        console.dir(e);
        if (e.response) {
          const errorMessage = e.response.data.message;
          One.helpers("jq-notify", { type: "danger", icon: "fa fa-check me-1", message: errorMessage });
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.btn-invoice-export {
  justify-self: start;
  width: fit-content;
}
</style>

<style lang="scss">
.expert-loader {
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.9);
  z-index: 2;
  justify-content: center;
  align-items: center;
}

.mini-btn {
  button {
    font-size: 12px;
    height: auto;
    padding: 0 8px;
    line-height: 2;

    &.btn-default {
      border: 1px solid #dadada;
    }
  }
}

.dnc-badge {
  font-size: 0.9em;
  font-weight: bold;
}
</style>
